/* ============================================
   Product Add-on Web Component
   Fetches product data and renders inline card
   with AJAX add-to-cart via CartAPI
   ============================================ */

if (!customElements.get('product-addon')) {
  class ProductAddon extends HTMLElement {
    connectedCallback() {
      this.handle = this.dataset.handle;
      if (!this.handle) return;
      this.loadProduct();
    }

    async loadProduct() {
      try {
        const res = await fetch(`/products/${this.handle}.js`);
        if (!res.ok) throw new Error('Not found');
        this.product = await res.json();
        this.render();
      } catch {
        this.remove();
      }
    }

    render() {
      const p = this.product;
      const variant = p.variants[0];
      const hasMultiple = p.variants.length > 1;

      const card = this.querySelector('.pdp-addon-card');
      card.replaceChildren();

      const inner = document.createElement('div');
      inner.className = 'pdp-addon-card__inner';

      if (p.featured_image) {
        const img = document.createElement('img');
        img.className = 'pdp-addon-card__img';
        img.src = p.featured_image.replace(/(\.\w+)(\?|$)/, '_120x$1$2');
        img.alt = p.title;
        img.width = 64;
        img.height = 64;
        img.loading = 'lazy';
        inner.appendChild(img);
      }

      const info = document.createElement('div');
      info.className = 'pdp-addon-card__info';

      const titleLink = document.createElement('a');
      titleLink.className = 'pdp-addon-card__title';
      titleLink.href = `/products/${p.handle}`;
      titleLink.textContent = p.title;
      info.appendChild(titleLink);

      const priceEl = document.createElement('span');
      priceEl.className = 'pdp-addon-card__price';
      priceEl.textContent = this.formatPrice(variant.price);
      info.appendChild(priceEl);

      if (hasMultiple) {
        const select = document.createElement('select');
        select.className = 'pdp-addon-card__variant-select select';
        select.setAttribute('aria-label', 'Choose variant for ' + p.title);
        p.variants.forEach(v => {
          const opt = document.createElement('option');
          opt.value = v.id;
          opt.textContent = v.title + (!v.available ? ' — Sold out' : '');
          opt.disabled = !v.available;
          select.appendChild(opt);
        });
        select.addEventListener('change', () => {
          const v = p.variants.find(v => v.id === Number(select.value));
          if (v) {
            priceEl.textContent = this.formatPrice(v.price);
            btn.dataset.variantId = v.id;
            /* Update image to match selected variant */
            const imgEl = inner.querySelector('.pdp-addon-card__img');
            if (imgEl && v.featured_image) {
              imgEl.src = v.featured_image.src.replace(/(\.\w+)(\?|$)/, '_120x$1$2');
              imgEl.alt = v.featured_image.alt || v.title;
            }
          }
        });
        info.appendChild(select);
      }

      inner.appendChild(info);

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pdp-addon-card__add btn btn-primary';
      btn.dataset.variantId = variant.id;
      btn.textContent = 'Add';
      btn.addEventListener('click', () => this.addToCart(btn));
      inner.appendChild(btn);

      card.appendChild(inner);
    }

    async addToCart(btn) {
      const variantId = Number(btn.dataset.variantId);
      btn.disabled = true;
      btn.textContent = 'Adding…';

      try {
        await CartAPI.add([{ id: variantId, quantity: 1 }]);
        btn.textContent = 'Added ✓';
        btn.classList.add('pdp-addon-card__add--success');
        setTimeout(() => {
          btn.textContent = 'Add';
          btn.classList.remove('pdp-addon-card__add--success');
          btn.disabled = false;
        }, 2000);
      } catch (err) {
        btn.textContent = 'Error';
        btn.classList.add('pdp-addon-card__add--error');
        setTimeout(() => {
          btn.textContent = 'Add';
          btn.classList.remove('pdp-addon-card__add--error');
          btn.disabled = false;
        }, 2000);
      }
    }

    formatPrice(cents) {
      return typeof formatMoney === 'function'
        ? formatMoney(cents)
        : '$' + (cents / 100).toFixed(2);
    }
  }

  customElements.define('product-addon', ProductAddon);
}
